import React from "react"
import { useWindowDimensions } from "../../hooks/useWindowDimensions"
import { IconButton } from "@mui/material"
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"

export const SliderLeftButton = (props) => {
    const { templates } = props
    const { width } = useWindowDimensions()
    return (
        <div>
            {templates.length > 3 && width > 600 ? (
                <IconButton
                    className="giftcards-prev"
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "absolute",
                        bottom: 135,
                        left: 15,
                        backgroundColor: "black",
                        "&:hover": { backgroundColor: "black" },
                        "@media (max-width:600px)": {
                            bottom: 200,
                        },
                    }}
                >
                    <ArrowBackIosNewIcon sx={{ color: "white" }} />
                </IconButton>
            ) : (
                width < 600 && (
                    <IconButton
                        className="giftcards-prev"
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "absolute",
                            bottom: 135,
                            left: 15,
                            backgroundColor: "black",
                            "&:hover": { backgroundColor: "black" },
                            "@media (max-width:600px)": {
                                bottom: 200,
                            },
                        }}
                    >
                        <ArrowBackIosNewIcon sx={{ color: "white" }} />
                    </IconButton>
                )
            )}
        </div>
    )
}
